import React, { memo, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createUseStyles, Text, Tabs, SelectWrapper, Select } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import styles from './styles';

const useStyles = createUseStyles(styles, 'SectionTabs');

function SectionTabs({
    onChange,
    onChangeShrinked,
    activeTab,
    activeShrinkedTab,
    shrinkedTabs,
    tabs = [],
}) {
    const classes = useStyles();
    const { t } = useWeb5Context();

    // Check if the activeTab is one of the shrinked tabs
    const isShrinkedTabActive = useMemo(() => {
        if (!activeShrinkedTab || !shrinkedTabs) return false;
        return !activeTab || activeTab === activeShrinkedTab.value;
    }, [activeTab, activeShrinkedTab, shrinkedTabs]);

    const shrinkedTab = classnames(classes.shrinkedTab, {
        [classes.activeShrinkedTab]: isShrinkedTabActive,
    });
    const newSelectRef = useRef(null);

    const getSelectRef = (ref) => {
        if (ref) newSelectRef.current = ref;
    };

    const getIsOpen = (isOpen) => {
        if (newSelectRef && newSelectRef.current) {
            if (isOpen)
                setTimeout(() => {
                    newSelectRef.current.focus();
                }, 50);
        }
    };

    const shrinkedTabSelect = { select: classes.shrinkedTabSelect };
    const postComponent = shrinkedTabs && (
        <SelectWrapper
            getIsOpen={getIsOpen}
            customOptions={
                <Select
                    placeholder={t('cfm_action_search')}
                    onChange={onChangeShrinked}
                    options={shrinkedTabs}
                    value={activeShrinkedTab}
                    classes={shrinkedTabSelect}
                    getRef={getSelectRef}
                    useMenuPortal={false}
                    menuPosition="absolute"
                    isFullWidth
                    highlightMatch
                    forceMenuIsOpen
                    autoFocus
                />
            }
        >
            <Text
                className={[
                    classes.shrinkedTabText,
                    activeShrinkedTab ? activeShrinkedTab.label : t('cfm_label_select_other_table'),
                ]}
                type="body"
            >
                {activeShrinkedTab ? activeShrinkedTab.label : t('cfm_label_select_other_table')}
            </Text>
        </SelectWrapper>
    );

    return (
        <div className={classes.root}>
            <Tabs
                className={classes.tabsRoot}
                activeKey={isShrinkedTabActive ? '' : activeTab}
                tabs={tabs}
                onChange={onChange}
                postComponent={postComponent}
                classes={{
                    postComponent: shrinkedTab,
                }}
            />
        </div>
    );
}

SectionTabs.propTypes = {
    onChange: PropTypes.func,
    onChangeShrinked: PropTypes.func,
    activeTab: PropTypes.string,
    activeShrinkedTab: PropTypes.shape({
        label: PropTypes.string,
        valu: PropTypes.string,
    }),
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            title: PropTypes.string,
        }),
    ),
    shrinkedTabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            valu: PropTypes.string,
        }),
    ),
};

export default memo(SectionTabs);
